// Presentation only: retain every authored item and its audio reference/order.
export function readAloudPages(groups: any[]) {
  const pages: {title: string; items: any[]; toneFamily:boolean; base?:string}[] = [];
  const base = (pinyin: string) => pinyin.normalize('NFD').replace(/[\u0300\u0301\u0304\u030c]/g, '').normalize('NFC');
  for (const group of groups) {
    for (let index = 0; index < group.items.length;) {
      const family = group.items.slice(index, index + 4);
      const tones = ['\u0304', '\u0301', '\u030c', '\u0300'];
      const toneFamily = family.length === 4 && family.every((item: any, i: number) =>
        base(item.pinyin) === base(family[0].pinyin) && item.pinyin.normalize('NFD').includes(tones[i]));
      const items = toneFamily ? family : group.items.slice(index, index + 4);
      const title=String(group.title??'').replace(/^Сочетания? слогов\s*[·×x]\s*1$/u,'Сочетание слогов');
      pages.push({title: toneFamily ? `Слог ${base(items[0].pinyin)}` : title, items,toneFamily,base:toneFamily?base(items[0].pinyin):undefined});
      index += items.length;
    }
  }
  return pages;
}
